(function () {
  var CM_SEARCH_URL = "https://oewholesale1.myconvermax.com/search.json";
  var VEHICLE_STORAGE_KEY = "cm_selected_vehicle";

  function loadPersistedVehicle() {
    try {
      var raw = localStorage.getItem(VEHICLE_STORAGE_KEY);
      if (!raw) return null;

      var vehicle = JSON.parse(raw);
      if (!vehicle || !vehicle.year || !vehicle.make || !vehicle.model) return null;
      return vehicle;
    } catch (e) {
      return null;
    }
  }

  function parseVehicleFromUrl() {
    var raw = window.location.search.replace(/^\?/, "");
    if (!raw) return null;

    var segments = raw.split("/").map(decodeURIComponent);
    var vehicle = {};

    segments.forEach(function (segment, index) {
      if (segment === "Year") vehicle.year = segments[index + 1];
      if (segment === "Make") vehicle.make = segments[index + 1];
      if (segment === "Model") vehicle.model = segments[index + 1];
    });

    if (!vehicle.year || !vehicle.make || !vehicle.model) return null;
    return vehicle;
  }

  function buildFitmentUrl(productId, variantId, vehicle) {
    var url = new URL(CM_SEARCH_URL);
    url.searchParams.set("filterquery", "id:" + productId);
    url.searchParams.set("pagesize", "1");
    url.searchParams.set("mode", "VerifyFitment");
    url.searchParams.set("facet.0.field", "Year");
    url.searchParams.set("facet.0.selection", vehicle.year);
    url.searchParams.set("facet.1.field", "Make");
    url.searchParams.set("facet.1.selection", vehicle.make);
    url.searchParams.set("facet.2.field", "Model");
    url.searchParams.set("facet.2.selection", vehicle.model);
    url.searchParams.set("extra.country", "us");
    url.searchParams.set("extra.currency", "usd");
    url.searchParams.set("extra.currencyrate", "1.0");
    url.searchParams.set("extra.locale", "en");
    if (variantId) url.searchParams.set("extra.variantid", variantId);
    url.searchParams.set("variantsMode", "Strip");

    return url.toString();
  }

  function initVehicleModal() {
    var modal = document.getElementById("ProductFitmentVehicleModal");
    if (!modal) return null;

    var form = modal.querySelector(".product-fitment-vehicle-modal-form");
    if (form && window.cmInitVehiclePanel) {
      window.cmInitVehiclePanel(form, {
        onSubmit: function (vehicle) {
          try {
            localStorage.setItem(
              VEHICLE_STORAGE_KEY,
              JSON.stringify({ year: vehicle.year, make: vehicle.make, model: vehicle.model })
            );
          } catch (e) {}

          var fitmentPath =
            "Fitment/Vehicle-Specific/Year/" +
            encodeURIComponent(vehicle.year) +
            "/Make/" +
            encodeURIComponent(vehicle.make) +
            "/Model/" +
            encodeURIComponent(vehicle.model);
          window.history.pushState({}, "", window.location.pathname + "?" + fitmentPath);

          document.dispatchEvent(new CustomEvent("cm:vehicle-changed", { detail: vehicle }));
          modal.hide();
        },
      });
    }

    return modal;
  }

  function initBanner(banner) {
    var productId = banner.dataset.productId;
    if (!productId) return;

    var variantId = banner.dataset.variantId;
    var fitLabel = banner.querySelector(".product-fitment-banner-fit-label");
    var vehicleText = banner.querySelector(".product-fitment-banner-vehicle");
    var changeButton = banner.querySelector(".product-fitment-banner-change");
    var notice = document.querySelector(".product-fitment-notice");
    var selectButton = notice ? notice.querySelector(".product-fitment-notice-select") : null;

    var fitmentRequest = 0;

    function hideBanner() {
      fitmentRequest += 1;
      banner.hidden = true;
      banner.classList.remove("product-fitment-banner-no-fit");
      if (fitLabel) fitLabel.textContent = "";
      if (vehicleText) vehicleText.textContent = "";
      if (notice) notice.hidden = false;
    }

    function checkFitment(vehicle) {
      if (!vehicle || !vehicle.year || !vehicle.make || !vehicle.model) {
        hideBanner();
        return;
      }
      var requestId = ++fitmentRequest;
      fetch(buildFitmentUrl(productId, variantId, vehicle))
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (requestId !== fitmentRequest) return;
          var fits = Boolean(data.TotalHits) && data.TotalHits > 0;
          var vehicleLabel = vehicle.year + " " + vehicle.make + " " + vehicle.model;

          banner.classList.toggle("product-fitment-banner-no-fit", !fits);
          if (fitLabel) {
            fitLabel.textContent = fits ? "This product fits your" : "This product does NOT fit your";
          }
          if (vehicleText) vehicleText.textContent = vehicleLabel;

          banner.hidden = false;
          if (notice) notice.hidden = true;
        })
        .catch(function () {});
    }

    var modal = initVehicleModal();

    function openModal(opener) {
      if (modal) {
        modal.show(opener);
      } else {
        document.dispatchEvent(new CustomEvent("cm:open-vehicle-picker"));
      }
    }

    if (changeButton) {
      changeButton.addEventListener("click", function () {
        openModal(changeButton);
      });
    }

    if (selectButton) {
      selectButton.addEventListener("click", function () {
        openModal(selectButton);
      });
    }

    document.addEventListener("cm:vehicle-changed", function (event) {
      checkFitment(event.detail);
    });
    document.addEventListener("cm:vehicle-cleared", hideBanner);

    var initialVehicle = parseVehicleFromUrl() || loadPersistedVehicle();
    if (initialVehicle) checkFitment(initialVehicle);
  }

  function init() {
    document.querySelectorAll(".product-fitment-banner").forEach(initBanner);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
